import { StyleSheet } from 'aphrodite';
import {
	borderColor,
	brandPrimary,
	brandPrimaryHover,
	error,
	grayIconFill,
	success,
	titles,
	white,
} from '../../styles/colors';
import { aidaBaseStyles } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	modal: {
		backgroundColor: white,
		border: `1px solid ${borderColor}`,
		borderRadius: 8,
		boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
		left: 20,
		maxHeight: '80vh',
		overflowY: 'auto',
		padding: 20,
		position: 'fixed',
		top: 20,
		width: 420,
		zIndex: 1000,
	},
	header: {
		...aidaBaseStyles.flexHorizontalCenter,
		justifyContent: 'space-between',
		marginBottom: 16,
	},
	title: {
		color: titles,
		fontSize: '16px',
		fontWeight: 600,
	},
	closeButton: {
		':hover': {
			color: titles,
		},
		background: 'none',
		border: 'none',
		color: grayIconFill,
		cursor: 'pointer',
		fontSize: '20px',
		padding: '0 4px',
	},
	loadingContainer: {
		...aidaBaseStyles.flexCol,
		alignItems: 'center',
		padding: '40px 0',
	},
	loadingText: {
		color: grayIconFill,
		fontSize: '14px',
		marginTop: 12,
	},
	errorContainer: {
		...aidaBaseStyles.flexCol,
		alignItems: 'center',
		padding: '20px 0',
	},
	errorText: {
		color: error,
		fontSize: '14px',
		marginBottom: 12,
	},
	noResultsText: {
		color: grayIconFill,
		fontSize: '14px',
		padding: '20px 0',
		textAlign: 'center',
	},
	matchRow: {
		':not(:last-child)': {
			borderBottom: `1px solid ${borderColor}`,
			marginBottom: 12,
			paddingBottom: 12,
		},
	},
	matchHeader: {
		...aidaBaseStyles.flexHorizontalCenter,
		justifyContent: 'space-between',
		marginBottom: 4,
	},
	phoneNumber: {
		color: titles,
		fontSize: '14px',
		fontWeight: 600,
	},
	matchedName: {
		color: grayIconFill,
		fontSize: '12px',
		marginBottom: 4,
	},
	confidenceBadge: {
		borderRadius: 4,
		color: white,
		fontSize: '11px',
		fontWeight: 600,
		padding: '2px 6px',
	},
	confidenceHigh: {
		backgroundColor: success,
	},
	confidenceMediumHigh: {
		backgroundColor: '#f59e0b',
	},
	confidenceMedium: {
		backgroundColor: '#f97316',
	},
	confidenceUnresolved: {
		backgroundColor: grayIconFill,
	},
	metaRow: {
		...aidaBaseStyles.flexHorizontalCenter,
		gap: 6,
		marginBottom: 4,
	},
	metaLabel: {
		color: grayIconFill,
		fontSize: '11px',
	},
	disconnectedBadge: {
		backgroundColor: '#fef2f2',
		borderRadius: 4,
		color: error,
		fontSize: '10px',
		fontWeight: 600,
		padding: '1px 4px',
	},
	reasons: {
		color: grayIconFill,
		fontSize: '11px',
		marginBottom: 4,
	},
	notes: {
		color: grayIconFill,
		fontSize: '11px',
		fontStyle: 'italic',
		marginBottom: 8,
	},
	wrongNumberBadge: {
		backgroundColor: error,
		borderRadius: 4,
		color: white,
		fontSize: '11px',
		fontWeight: 600,
		padding: '2px 6px',
	},
	actions: {
		...aidaBaseStyles.flexHorizontalCenter,
		gap: 8,
	},
	actionButton: {
		':hover': {
			backgroundColor: brandPrimaryHover,
		},
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.5,
		},
		backgroundColor: brandPrimary,
		border: 'none',
		borderRadius: 4,
		color: white,
		cursor: 'pointer',
		fontSize: '11px',
		padding: '4px 8px',
	},
	markWrongButton: {
		':hover': {
			backgroundColor: '#dc2626',
		},
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.5,
		},
		backgroundColor: error,
		border: 'none',
		borderRadius: 4,
		color: white,
		cursor: 'pointer',
		fontSize: '11px',
		padding: '4px 8px',
	},
	retryButton: {
		':hover': {
			backgroundColor: brandPrimaryHover,
		},
		backgroundColor: brandPrimary,
		border: 'none',
		borderRadius: 4,
		color: white,
		cursor: 'pointer',
		fontSize: '12px',
		padding: '6px 12px',
	},
	addedBadge: {
		backgroundColor: success,
		borderRadius: 4,
		color: white,
		fontSize: '11px',
		fontWeight: 600,
		padding: '2px 6px',
	},
});
